module.exports = __webpack_public_path__ + "media/94.385514a6.mp3";